import Height  from '../core/iframe';

const SetIframeHeight = function () {
    Height(function (data) {
        let iframe = document.querySelector("iframe.document-height");
        let height = data + 50;
        iframe.style.cssText = 'height:' + height + 'px';
    });
}

module.exports = {
    SetIframeHeight
};




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/IframeView.js